var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"p-4",attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"text-h6"},[_vm._v(" CO2 Emissions Divided Per Scope 1, 2, and 3 in Relation to Number of Employees ")]),_c('v-card-text',[_c('div',{staticClass:"chart-container"},[_c('canvas',{ref:"emissionChart"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }